import { useEffect, useState, useContext } from 'react';
import axios from 'axios';

import { AppContext } from 'contexts/AppContext';
import { UserContext } from 'contexts/UserContext';
import { getHouseholdMemberStatus } from 'services/userService';

const DEFAULT_TYPE = 'prospect';
const DEFAULT_STATUS = 'Not Started';

const useAsyncHouseholdMemberStatus = setError => {
  const [ status, setStatus ] = useState({ 
    isLoading: true 
  });
  const { organizationId, propertyId } = useContext(AppContext);
  const {
    userProfile: {
      customerId,
      householdId,
      isProspect,
    },
  } = useContext(UserContext);

  useEffect(() => {
    const source = axios.CancelToken.source();
    let subscribed = true;

    const fetchStatus = async () => {
      const { token } = source;
      const options = { cancelToken: token };

      const response = await getHouseholdMemberStatus({
        organizationId,
        propertyId,
        customerId,
        householdId,
      }, options);

      if (subscribed) {
        if (response.error) {
          setError(`[${response.status}] There was a problem retrieving your member status`);
        } else {
          const { type, status, areFeesApplied } = response;
          setStatus({
            isLoading: false,
            type,
            status,
            areFeesApplied,
          });
        }
      }
    };

    if (customerId && householdId) {
      fetchStatus();
    }
    if (isProspect === true) {
      setStatus({
        isLoading: false,
        type: DEFAULT_TYPE,
        status: DEFAULT_STATUS,
        areFeesApplied: false,
      });
    }

    return () => {
      subscribed = false;
    };
  }, [organizationId, propertyId, customerId, householdId, isProspect, setError]);

  return status;
};

export default useAsyncHouseholdMemberStatus;
